module.exports = __webpack_public_path__ + "img/back_to_top.3bfbbc80.svg";